import { __assign, __rest } from "tslib";
import classNames from "classnames";
import React, { useEffect, useImperativeHandle, useRef, useState } from "react";
import styles from './text-field.module.css';
export var TextField = React.forwardRef(function (_a, outerRef) {
    var 
    // html props
    type = _a.type, id = _a.id, name = _a.name, disabled = _a.disabled, 
    // custom props
    label = _a.label, validation = _a.validation, large = _a.large, responsive = _a.responsive, props = __rest(_a, ["type", "id", "name", "disabled", "label", "validation", "large", "responsive"]);
    var cleansedProps = __assign(__assign({}, props), { 
        // html props
        type: type, id: id !== null && id !== void 0 ? id : label, name: name !== null && name !== void 0 ? name : label, disabled: disabled, 
        // custom props
        label: undefined, validation: undefined, large: undefined, responsive: undefined });
    var innerRef = useRef(null);
    useImperativeHandle(outerRef, function () { return innerRef.current; }, []);
    var _b = useState(''), value = _b[0], setValue = _b[1];
    var _c = useState(false), passwordVisible = _c[0], setPasswordVisible = _c[1];
    useEffect(function () {
        setValues(!!props.value ? props.value : props.defaultValue);
    }, [props.defaultValue, props.value]);
    function setValues(temp) {
        if (value !== temp)
            setValue(temp !== null && temp !== void 0 ? temp : '');
        if (!!innerRef.current && innerRef.current.value !== temp)
            innerRef.current.value = temp !== null && temp !== void 0 ? temp : '';
    }
    function onInputHandler(event) {
        var temp = event.currentTarget.value.toString();
        setValues(temp);
    }
    return (React.createElement("div", { className: classNames('fieldValidationWrapper', { responsive: responsive }) },
        React.createElement("div", { className: classNames('inputWrapper textField text', {
                populated: !!value,
                validation: (validation === null || validation === void 0 ? void 0 : validation.dirty) && (validation === null || validation === void 0 ? void 0 : validation.invalid),
                disabled: disabled,
                large: large,
                responsive: responsive,
                suffix: type === 'password',
            }) },
            React.createElement("label", { htmlFor: id !== null && id !== void 0 ? id : label, className: "inputLabel inputText" }, label),
            React.createElement("input", __assign({}, cleansedProps, { ref: innerRef, className: "inputTriggerWrapper inputTrigger inputText", type: type === 'password' && passwordVisible ? 'text' : type, onInput: onInputHandler })),
            type === 'password' && (React.createElement("div", { className: classNames('inputIcon suffix', styles.passwordToggle), tabIndex: -1, onClick: function () {
                    var _a;
                    setPasswordVisible(function (currentState) { return !currentState; });
                    (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                    setTimeout(function () {
                        if (!innerRef.current)
                            return;
                        innerRef.current.setSelectionRange(value.length, value.length);
                    });
                } },
                React.createElement("svg", { fill: "none", viewBox: "0 0 17 13" },
                    React.createElement("path", { fill: "var(--accent-2)", d: "M8.12997 2.42854c2.80113 0 5.29923 1.5214 6.51873 3.92848-1.2195 2.40709-3.7176 3.92848-6.51873 3.92848-2.80114 0-5.29926-1.52139-6.51876-3.92848 1.2195-2.40708 3.71762-3.92848 6.51876-3.92848Zm0-1.42854C4.43453 1 1.27862 3.22138 0 6.35702 1.27862 9.49267 4.43453 11.714 8.12997 11.714c3.69543 0 6.85133-2.22133 8.12993-5.35698C14.9813 3.22138 11.8254 1 8.12997 1Zm0 3.57135c1.01994 0 1.84772.79998 1.84772 1.78567 0 .9857-.82778 1.78568-1.84772 1.78568s-1.84772-.79998-1.84772-1.78568c0-.98569.82778-1.78567 1.84772-1.78567Zm0-1.42854c-1.83294 0-3.3259 1.44283-3.3259 3.21421 0 1.77139 1.49296 3.21422 3.3259 3.21422 1.83294 0 3.32593-1.44283 3.32593-3.21422 0-1.77138-1.49299-3.21421-3.32593-3.21421Z" }),
                    passwordVisible && (React.createElement("g", { id: "hide" },
                        React.createElement("path", { fill: "var(--accent-2)", d: "m3.69934.285156 10.557811 10.557811-.707106.707107L2.992233.992263z" }),
                        React.createElement("path", { fill: "var(--background)", d: "m2.99219.992188 10.557811 10.557811-.707106.707107L2.285083 1.699295z" })))),
                React.createElement("span", { className: "visibilityToggle" }, passwordVisible ? 'Hide' : 'Show')))),
        !!validation && (React.createElement("div", { className: classNames('fieldValidation fieldErrorMessage', { invisible: !validation.dirty || !validation.invalid }) }, validation.message))));
});
TextField.displayName = 'TextField';
export default TextField;
